import { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import useNotification from "../../../../../components/notification/useNotification";
import { isSuccessResponse } from "../../../../../common/utils";
import { Status } from "../../../../../common/constants";
import {
  deleteOrganization,
  selector as deleteOrganizationApi,
} from "./deleteOrganizationSlice";
import { fetchOrganizationData } from "../../../listOrganizationSlice";
import { actions as spinnerActions } from "../../../../../components/ui/spinner/spinnerSlice";

export const useDeleteOrganizationModal = (orgId) => {
  const dispatch: any = useDispatch();

  const [showModel, setShowModel] = useState<boolean>(false);

  const handleClose = useCallback(() => {
    setShowModel(false);
  }, []);

  const handleShow = useCallback(() => {
    setShowModel(true);
  }, []);

  const { showSuccessNotification, showWarningNotification } =
    useNotification();

  const handleDeleteButtonClick = () => {
    handleClose();
    try {
      dispatch(spinnerActions.setApiStatus(Status.PENDING));
      dispatch(deleteOrganization({ orgId })).then((response) => {
        if (isSuccessResponse(response.payload)) {
          dispatch(fetchOrganizationData());
          showSuccessNotification(response.payload.message);
          dispatch(spinnerActions.setApiStatus(Status.SUCCESS));
        } else {
          dispatch(spinnerActions.setApiStatus(Status.FAILED));
          showWarningNotification(response.error.message);
        }
      });
    } catch (error) {
      dispatch(spinnerActions.setApiStatus(Status.FAILED));

      console.error("Error deleting Organization:", error);
    }
  };

  return {
    handleDeleteButtonClick,
    showModel,
    handleShow,
    handleClose,
  };
};
